import { useEffect } from "react";
//context
import { useGlobalContext } from "../contexts";
//apollo
import client from "../src/utils/apollo/client";
//queries
import { GET_PAGES_URI } from "../src/queries/pages/get-pages";
import { GET_PAGE } from "../src/queries/pages/get-page";
//routing
import { useRouter } from "next/router";
import { FALLBACK, handleRedirectsAndReturnData, isCustomPageUri } from '../src/utils/slug';
//externals
import { isEmpty } from "lodash";
//components
import Layout from "../src/components/layout";

const Page = ( { data } ) => {
  const router = useRouter();
  if( router.isFallback ) {
    return <div>Loading...</div>
  }

  const { context, setContext } = useGlobalContext();

  useEffect(() => {
    if (!context.isSet) {
      data.context.options.isSet = true;
      setContext(data.context.options);
    }
  }, []);

  return (
    <Layout
      logos={data?.logos?.options?.logos}
      mainMenu={data?.mainMenu?.edges}
      menuFooter={data?.menuFooter?.edges}
      seo={data?.content?.seo}
      breadcrumbs={data?.content?.seo?.breadcrumbs}
      content={data?.content}
      teamMembers={data?.teamMembers}
      partners={data?.partners?.options?.partners}
      testimonies={data?.testimonies?.nodes}
      commercialAgents={data?.commercialAgents?.options?.commercialAgents}
      showrooms={data?.showrooms?.options?.showrooms}
      lastnews={data?.lastnews?.nodes}
      systems={data?.systems?.nodes}
      pt_key={process.env.PAGE_PT_KEY}
      templateWhite={data?.content?.acfSidebar?.bgWhite}
      optionsFooter={data?.content?.acfSidebar?.optionsFooter}
    >

    </Layout>
  )
}

export default Page;

export async function getStaticProps( {params} ) {
  const { data: data, errors: errors } = await client.query({
    query: GET_PAGE(process.env.PAGE_PT_KEY),
    variables: {
      uri: params?.slug.join("/"),
      systemsCategoryId: parseInt(process.env.PRODUCT_SYSTEMS_CATEGORY_ID)
    }
  });

  const defaultProps = {
		props: {
			data: data || {}
		},
		revalidate: 1,
	};

  return handleRedirectsAndReturnData( defaultProps, data, errors, 'page' );
};

export async function getStaticPaths(context) {
  const { data } = await client.query({
    query: GET_PAGES_URI
  });

  const pathsData = [];

  data?.pages?.nodes &&  data?.pages?.nodes?.map( page => {
    if (! isEmpty( page?.uri ) && ! isCustomPageUri( page?.uri )) {
      const slugs = page?.uri?.split('/').filter( pageSlug => pageSlug);
      pathsData.push( {params: { slug: slugs }} );
    }
  });

  return {
    paths: pathsData,
    fallback: FALLBACK,
  }
}